import React from 'react';

import { Box } from '@sunwisesoftware/sunwise-ui';
import i18next from 'i18next';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';

import { ControlledMap, StaticMap } from 'common/components';
import { DEFAULT_MAP_PREVIEW_ZOOM } from 'common/constants';

const ReactHookFormMap = ({
    center,
    control,
    disabled,
    height = '250',
    id,
    name,
    onChange,
    title = i18next.t('Location'),
    zoom = DEFAULT_MAP_PREVIEW_ZOOM,
}) => (
    <Controller
        control={control}
        name={name}
        render={({ field: { onChange: onChangeField, value } }) => (
            <Box
                sx={{
                    borderRadius: (theme) => `${theme.shape.borderRadius}px`,
                    overflow: 'hidden',
                }}
            >
                {disabled && !isEmpty(value) && (
                    <StaticMap
                        center={{ lat: value.latitude, lng: value.longitude }}
                        height={height}
                    />
                )}

                <Box hidden={disabled}>
                    <ControlledMap
                        center={center}
                        heightMap={`${height}px`}
                        id={id}
                        onChange={(e) => {
                            onChangeField(e);
                            if (onChange) onChange(e);
                        }}
                        title={title}
                        value={value}
                        zoom={zoom}
                    />
                </Box>
            </Box>
        )}
    />
);

ReactHookFormMap.propTypes = {
    center: PropTypes.object,
    control: PropTypes.object,
    disabled: PropTypes.bool,
    height: PropTypes.string,
    id: PropTypes.string,
    name: PropTypes.string,
    onChange: PropTypes.func,
    title: PropTypes.string,
    zoom: PropTypes.number,
};

export default ReactHookFormMap;
